import { useState, useEffect } from "react";
import { Modal } from "../components/Modal.jsx";

const DATALIST_ID = "kainininkas-known-suppliers";

const inputStyle = { border: "1px solid #e5e7eb", borderRadius: 6, padding: "6px 8px", fontSize: 13, boxSizing: "border-box" };

// Vienos eilutės (prekės) tiekėjų sąrašas — viena prekė gali turėti kelis
// tiekėjus skirtingomis kainomis/kodais. Lokalus `draft` duoda laisvą
// rašymą (kaip EditableDataTable'o langeliai), `onBlur` kiekvieną pakeistą
// lauką išsaugo atskirai per `onUpdate` — `version` optimistiniam lockui
// visada imama iš `entries` prop'o (paskutinė serverio patvirtinta reikšmė),
// ne iš vietinio juodraščio, kad rikiuojant kelis greitus pakeitimus
// nebūtų siunčiama pasenusi versija.
export function RowSuppliersModal({ rowLabel, entries, knownSuppliers, onClose, onAdd, onUpdate, onDelete }) {
  const [draft, setDraft] = useState(entries);
  useEffect(() => { setDraft(entries); }, [entries]);

  function updateLocal(id, patch) {
    setDraft(prev => prev.map(e => (e.id === id ? { ...e, ...patch } : e)));
  }

  return (
    <Modal title={`Tiekėjai: ${rowLabel || "(be pavadinimo)"}`} onClose={onClose}>
      <datalist id={DATALIST_ID}>
        {knownSuppliers.map(name => <option key={name} value={name} />)}
      </datalist>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {draft.length === 0 && <p style={{ fontSize: 13, color: "#9ca3af" }}>Tiekėjų dar nėra.</p>}
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {draft.map(entry => {
            const original = entries.find(e => e.id === entry.id);
            return (
              <div key={entry.id} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input list={DATALIST_ID} autoComplete="off" value={entry.supplier} placeholder="Tiekėjas"
                  onChange={e => updateLocal(entry.id, { supplier: e.target.value })}
                  onBlur={() => { if (original && entry.supplier.trim() && entry.supplier !== original.supplier) onUpdate(original, { supplier: entry.supplier.trim() }); }}
                  style={{ ...inputStyle, flex: 1 }} />
                <input value={entry.code} placeholder="Prekės kodas"
                  onChange={e => updateLocal(entry.id, { code: e.target.value })}
                  onBlur={() => { if (original && entry.code !== original.code) onUpdate(original, { code: entry.code }); }}
                  style={{ ...inputStyle, width: 130 }} />
                <input value={entry.price} placeholder="Kaina" type="number"
                  onChange={e => updateLocal(entry.id, { price: e.target.value })}
                  onBlur={() => { if (original && entry.price !== original.price) onUpdate(original, { price: entry.price }); }}
                  style={{ ...inputStyle, width: 100 }} />
                <button onClick={() => onDelete(entry)} style={{ background: "none", border: "none", color: "#d1d5db", cursor: "pointer", fontSize: 16 }}>×</button>
              </div>
            );
          })}
        </div>
        <button onClick={onAdd}
          style={{ background: "none", border: "1px dashed #d1d5db", borderRadius: 8, padding: "6px 14px", fontSize: 12, color: "#9ca3af", cursor: "pointer", alignSelf: "flex-start" }}>
          + Pridėti tiekėją
        </button>
      </div>
    </Modal>
  );
}
